export default {
  registration: {
    header: {
      // title: "",
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: "Cette page d'enregistrement est spécifique à une entreprise qui vous a demandé d'utiliser ce service.",
      section_two: "Veuillez saisir un code d'accès pour accéder à la page d'enregistrement.",
      section_three: "Si vous n'avez pas reçu de code d'accès, veuillez contacter l'entreprise qui a demandé à utiliser ce service.",
      passcode: "Code d'accès pour la visualisation",
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Entrée incorrecte.',
      unexpected_error: "Une erreur inattendue s'est produite",
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Veuillez saisir votre adresse e-mail pour vous enregistrer.',
      email: 'Adresse e-mail',
      email_placeholder: "Entrer l'adresse e-mail",
    },
    sent: {
      section_one: "Nous avons envoyé un e-mail à l'adresse que vous avez indiquée.",
      // section_two: "",
      section_three: "Si vous ne recevez pas d'e-mail dans les 30 minutes, veuillez contacter ",
      section_four: '.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: "L'adresse e-mail que vous avez saisie est déjà utilisée pour le compte ASUENE/ASUENE ESG.",
      section_two: 'Connectez-vous avec votre mot de passe.',
      password: 'Mot de passe',
      password_placeholder: 'Veuillez entrer votre mot de passe',
      error_auth: "L'authentification a échoué. Veuillez vous connecter à nouveau",
      error_linking: "L'authentification a échoué.Veuillez saisir à nouveau le mot de passe",
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Veuillez saisir les informations nécessaires pour compléter votre inscription.',
      section_three: "Connectez-vous avec votre compte enregistré après votre demande et vous pourrez répondre à l'enquête demandée.",
      // buyer_name: "",
      expires_date: "Date d'expiration",
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: "Nom de l'entreprise",
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: "L'adresse e-mail que vous avez saisie s'affiche",
      // phone: "",
      phone_placeholder: '0000000000',
      locale: 'Sélectionner la langue',
      // section_one: "",
      rule: 'Veuillez accepter les conditions générales',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' et',
      policy: ' la politique de confidentialité',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: ' avant de continuer.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'Merci pour votre enregistrement.',
      section_two: "Nous avons envoyé votre identifiant de connexion et votre mot de passe à l'adresse e-mail que vous avez indiquée.",
      section_three: 'Veuillez vérifier votre e-mail et suivre les instructions qui y figurent pour vous connecter.',
      section_four: "Si vous ne recevez pas d'e-mail dans les 30 minutes, ",
      // section_five: "",
      // section_six: "",
    },
    expired: {
      section_one: "L'URL fournie est déjà expiré",
      section_two: 'Si vous souhaitez utiliser ce service, veuillez contacter',
      section_three: 'La personne responsable vous contactera.',
    },
    error: {
      section_one: "L'URL fournie n'a pas pu être trouvée.",
      section_two: "Désolé pour ce désagrément, mais veuillez vérifier à nouveau l'URL.",
    },
    btn: {
      submit: 'Envoyer',
      service_top: 'Haut de page',
      // login: "",
      register: 'Enregistrer',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
